import { 
  verificationCallWithValid, 
  registerUser, 
  serviceNumberLogin,
  getUserDetailsByServiceNo,
  getServiceNumberByPhone,
  uploadProfileImage,
  getUserImageUrl
} from "../service/authService";
import { apiUrl } from "../service/apiUrl";

// Action Types
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const RESTORE_SESSION = "RESTORE_SESSION"; 
export const REGISTER_START = "REGISTER_START";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const SERVICE_LOGIN_SUCCESS = "SERVICE_LOGIN_SUCCESS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const LOGOUT = "LOGOUT";
export const SET_SERVICE_NUMBER = "SET_SERVICE_NUMBER";
export const SET_USER_IMAGE = "SET_USER_IMAGE";
export const UPLOAD_IMAGE_START = "UPLOAD_IMAGE_START";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE";
export const UPDATE_USER_START = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

// Action Creators
export const setServiceNumber = (serviceNo) => ({
  type: SET_SERVICE_NUMBER,
  payload: serviceNo
});

export const setUserImage = (imageUrl) => ({
  type: SET_USER_IMAGE,
  payload: imageUrl
});

export const uploadImageStart = () => ({
  type: UPLOAD_IMAGE_START
});

export const uploadImageSuccess = (imageUrl) => ({
  type: UPLOAD_IMAGE_SUCCESS,
  payload: imageUrl
});

export const uploadImageFailure = (error) => ({
  type: UPLOAD_IMAGE_FAILURE,
  payload: error
});

export const startAuthentication = () => ({
  type: AUTH_START,
});

export const authenticationSuccess = (data) => ({
  type: AUTH_SUCCESS,
  payload: data,
});

export const authenticationFailure = (error) => ({
  type: AUTH_FAILURE,
  payload: error,
});

export const setUserDetails = (userDetails) => ({
  type: SET_USER_DETAILS,
  payload: userDetails,
});

export const updateUserStart = () => ({
  type: UPDATE_USER_START
});

export const updateUserSuccess = (userData) => ({
  type: UPDATE_USER_SUCCESS,
  payload: userData
});

export const updateUserFailure = (error) => ({
  type: UPDATE_USER_FAILURE,
  payload: error
});

export const changePasswordStart = () => ({
  type: CHANGE_PASSWORD_START
});

export const changePasswordSuccess = () => ({
  type: CHANGE_PASSWORD_SUCCESS
});

export const changePasswordFailure = (error) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error
});

// Restore session from localStorage
export const restoreSession = () => (dispatch) => {
  const phoneNumber = localStorage.getItem("phoneNumber");
  const userData = localStorage.getItem("userData");
  const sentOtp = localStorage.getItem("sentOtp");
  const authKey = localStorage.getItem("authKey");
  const serviceNo = localStorage.getItem("serviceNo");
  const employeeName = localStorage.getItem("employeeName");
  const department = localStorage.getItem("department");
  const role = localStorage.getItem("role");
  const profileImage = localStorage.getItem("profileImage");
  
  // Check for service number login session
  if (serviceNo && authKey) {
    let parsedUserData = null;
    
    if (userData && userData !== "undefined" && userData !== "null") {
      try {
        parsedUserData = JSON.parse(userData);
      } catch (error) {
        console.warn("Failed to parse userData from localStorage:", error);
        localStorage.removeItem("userData");
      }
    }
    
    // Set service number in Redux
    dispatch(setServiceNumber(serviceNo));
    
    // Set user image URL
    let imageUrl = profileImage;
    if (!imageUrl) {
      imageUrl = getUserImageUrl(serviceNo);
      localStorage.setItem("profileImage", imageUrl);
    }
    dispatch(setUserImage(imageUrl));
    
    dispatch({
      type: RESTORE_SESSION,
      payload: {
        serviceNo,
        authKey,
        userData: parsedUserData || { 
          Name: employeeName, 
          Department: department, 
          Designation: role 
        },
        loginMethod: 'service'
      }
    });
    return true;
  }
  
  // Check for phone number login session
  if (phoneNumber) {
    let parsedUserData = null;
    
    if (userData && userData !== "undefined" && userData !== "null") {
      try {
        parsedUserData = JSON.parse(userData);
      } catch (error) {
        console.warn("Failed to parse userData from localStorage:", error);
        localStorage.removeItem("userData");
      }
    }
    
    // Set service number in Redux if available
    if (serviceNo) {
      dispatch(setServiceNumber(serviceNo));
      
      // Set user image URL
      let imageUrl = profileImage;
      if (!imageUrl) {
        imageUrl = getUserImageUrl(serviceNo);
        localStorage.setItem("profileImage", imageUrl);
      }
      dispatch(setUserImage(imageUrl));
    }
    
    dispatch({
      type: RESTORE_SESSION,
      payload: {
        phoneNumber,
        userData: parsedUserData || { 
          Name: employeeName, 
          Department: department, 
          Designation: role 
        },
        serviceNo: serviceNo,
        sentOtp: sentOtp || null,
        loginMethod: 'phone'
      }
    });
    
    // If we have service number but no details, fetch them
    if (serviceNo && (!employeeName || !department || !role)) {
      dispatch(fetchUserDetails(serviceNo));
    }
    
    return true;
  }
  return false;
};

// Logout user
export const logout = () => (dispatch) => {
  localStorage.removeItem("phoneNumber");
  localStorage.removeItem("userData");
  localStorage.removeItem("sentOtp");
  localStorage.removeItem("authKey");
  localStorage.removeItem("serviceNo");
  localStorage.removeItem("employeeId");
  localStorage.removeItem("employeeName");
  localStorage.removeItem("department");
  localStorage.removeItem("role");
  localStorage.removeItem("profileImage");
  
  dispatch({
    type: LOGOUT
  });
};

// Phone number authentication
export const authenticate = (phoneNo) => async (dispatch) => {
  dispatch(startAuthentication());
  try {
    const response = await verificationCallWithValid(phoneNo);
    
    if (response.success) {
      let serviceNo = response.serviceNo;
      
      // If serviceNo is not in OTP response, try to get it by phone
      if (!serviceNo) {
        try {
          const serviceResponse = await getServiceNumberByPhone(phoneNo);
          if (serviceResponse.success) {
            serviceNo = serviceResponse.serviceNo;
          }
        } catch (serviceError) {
          console.warn("Could not fetch service number by phone:", serviceError);
        }
      }
      
      // Store basic info in localStorage
      localStorage.setItem("phoneNumber", phoneNo);
      localStorage.setItem("sentOtp", response.otp);
      
      if (serviceNo) {
        localStorage.setItem("serviceNo", serviceNo);
        localStorage.setItem("employeeId", serviceNo);
        
        // Set service number in Redux
        dispatch(setServiceNumber(serviceNo));
        
        // Set user image URL
        const imageUrl = getUserImageUrl(serviceNo);
        localStorage.setItem("profileImage", imageUrl);
        dispatch(setUserImage(imageUrl));
        
        // Fetch and store user details
        try {
          const userDetailsResponse = await getUserDetailsByServiceNo(serviceNo);
          if (userDetailsResponse.success && userDetailsResponse.userData) {
            const userData = userDetailsResponse.userData;
            localStorage.setItem("employeeName", userData.Name || "");
            localStorage.setItem("department", userData.Department || "");
            localStorage.setItem("role", userData.Designation || "");
            localStorage.setItem("userData", JSON.stringify(userData));
            
            dispatch(setUserDetails(userData));
          }
        } catch (userError) {
          console.warn("Could not fetch user details:", userError);
        }
      }
      
      dispatch(authenticationSuccess({ 
        phoneNumber: phoneNo, 
        otp: response.otp,
        serviceNo: serviceNo
      }));
      
      return { 
        success: true, 
        data: response.otp, 
        serviceNo: serviceNo 
      };
    } else {
      throw { message: "Invalid phone number or verification failed." };
    }
  } catch (error) {
    dispatch(authenticationFailure(error));
    return { success: false, error };
  }
};

// Service number authentication
export const authenticateWithServiceNumber = (serviceNo, password) => async (dispatch) => {
  dispatch(startAuthentication());
  try {
    const response = await serviceNumberLogin(serviceNo, password);
    
    if (response.success) {
      // Store auth key and service number in localStorage
      localStorage.setItem("authKey", response.authKey);
      localStorage.setItem("serviceNo", serviceNo);
      localStorage.setItem("employeeId", serviceNo);
      localStorage.setItem("userData", JSON.stringify(response.userData));
      
      // Set service number in Redux
      dispatch(setServiceNumber(serviceNo));
      
      // Set user image URL
      const imageUrl = getUserImageUrl(serviceNo);
      localStorage.setItem("profileImage", imageUrl);
      dispatch(setUserImage(imageUrl));
      
      // Fetch and store user details
      try {
        const userDetailsResponse = await getUserDetailsByServiceNo(serviceNo);
        if (userDetailsResponse.success && userDetailsResponse.userData) {
          const userData = userDetailsResponse.userData;
          localStorage.setItem("employeeName", userData.Name || "");
          localStorage.setItem("department", userData.Department || "");
          localStorage.setItem("role", userData.Designation || "");
          
          // Update response with user details
          response.userData = { ...response.userData, ...userData };
          localStorage.setItem("userData", JSON.stringify(response.userData));
          
          dispatch(setUserDetails(userData));
        }
      } catch (userError) {
        console.warn("Could not fetch user details:", userError);
      }
      
      dispatch({
        type: SERVICE_LOGIN_SUCCESS,
        payload: {
          serviceNo,
          authKey: response.authKey,
          userData: response.userData
        }
      });
      
      return { success: true, data: response };
    } else {
      throw { message: "Invalid credentials" };
    }
  } catch (error) {
    dispatch(authenticationFailure(error));
    return { success: false, error };
  }
};

// Fetch user details by service number
export const fetchUserDetails = (serviceNo) => async (dispatch) => {
  try {
    const response = await getUserDetailsByServiceNo(serviceNo);
    
    if (response.success && response.userData) {
      const userData = response.userData;
      
      // Store in localStorage
      localStorage.setItem("employeeName", userData.Name || "");
      localStorage.setItem("department", userData.Department || "");
      localStorage.setItem("role", userData.Designation || "");
      localStorage.setItem("userData", JSON.stringify(userData));
      
      dispatch(setUserDetails(userData));
      return { success: true, data: userData };
    } else {
      return { success: false, message: response.message };
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
    return { success: false, error };
  }
};

// Upload profile image action
export const uploadProfileImageAction = (serviceNo, imageFile) => async (dispatch) => {
  dispatch(uploadImageStart());
  
  try {
    // Validate file
    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
    if (!validTypes.includes(imageFile.type)) {
      throw new Error("Please select a valid image file (JPEG, PNG, GIF, or WebP)");
    }
    
    if (imageFile.size > 5 * 1024 * 1024) {
      throw new Error("Image size should not exceed 5MB");
    }
    
    // Upload image
    const response = await uploadProfileImage(serviceNo, imageFile);
    
    if (response.success) {
      // Update image URL with timestamp to bypass cache
      const newImageUrl = getUserImageUrl(serviceNo);
      localStorage.setItem("profileImage", newImageUrl);
      dispatch(uploadImageSuccess(newImageUrl));
      
      return { 
        success: true, 
        imageUrl: newImageUrl,
        data: response.data 
      };
    } else {
      throw new Error("Upload failed");
    }
  } catch (error) {
    console.error("Image upload error:", error);
    dispatch(uploadImageFailure(error.message));
    return { success: false, error: error.message };
  }
};

// Update user details action
export const updateUserDetails = (userData) => async (dispatch) => {
  dispatch(updateUserStart());
  
  try {
    const response = await fetch(
      apiUrl(`UserRegister/UpdateUserDetails`),
      apiUrl(`UserRegister/PostUserDetails`),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "UserId": "DTSUSER",
          "Password": "Rayan@123"
        },
        body: JSON.stringify([userData])
      }
    );
    
    const result = await response.json();
    
    if (response.ok && result.statusCode === 200) {
      // Update Redux state
      dispatch(updateUserSuccess(userData));
      
      // Update localStorage
      localStorage.setItem("employeeName", userData.Name || "");
      localStorage.setItem("department", userData.Department || "");
      localStorage.setItem("role", userData.role || "");
      localStorage.setItem("userData", JSON.stringify(userData));
      
      return { success: true, data: result };
    } else {
      throw new Error(result.message || "Update failed");
    }
  } catch (error) {
    console.error("Update user error:", error);
    dispatch(updateUserFailure(error.message));
    return { success: false, error: error.message };
  }
};

// Change password action
export const changePassword = (serviceNo, currentPassword, newPassword) => async (dispatch) => {
  dispatch(changePasswordStart());
  
  try {
    const response = await fetch(
      apiUrl(`UserRegister/ChangePassword`),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "UserId": "DTSUSER",
          "Password": "Rayan@123"
        },
        body: JSON.stringify({
          serviceNo,
          currentPassword,
          newPassword
        })
      }
    );
    
    const result = await response.json();
    
    if (response.ok && result.statusCode === 200) {
      dispatch(changePasswordSuccess());
      return { success: true, data: result };
    } else {
      throw new Error(result.message || "Password change failed");
    }
  } catch (error) {
    console.error("Change password error:", error);
    dispatch(changePasswordFailure(error.message));
    return { success: false, error: error.message };
  }
};

// Resend OTP
export const resendOtp = (phoneNumber) => async (dispatch) => {
  try {
    const response = await verificationCallWithValid(phoneNumber);
    
    if (response.success) {
      // Update service number if available
      if (response.serviceNo) {
        localStorage.setItem("serviceNo", response.serviceNo);
        localStorage.setItem("employeeId", response.serviceNo);
        
        // Update Redux state
        dispatch(setServiceNumber(response.serviceNo));
        
        // Set user image URL
        const imageUrl = getUserImageUrl(response.serviceNo);
        localStorage.setItem("profileImage", imageUrl);
        dispatch(setUserImage(imageUrl));
      }
      
      // Update OTP in localStorage
      localStorage.setItem("sentOtp", response.otp);
      
      return { success: true, data: response.otp, serviceNo: response.serviceNo };
    } else {
      throw { message: "Failed to resend OTP." };
    }
  } catch (error) {
    console.error("Error resending OTP:", error);
    return { success: false, error };
  }
};

// Registration action
export const register = (userData) => async (dispatch) => {
  dispatch({ type: REGISTER_START });
  
  try {
    const response = await registerUser(userData);
    dispatch({
      type: REGISTER_SUCCESS,
      payload: response
    });
    return { success: true, data: response };
  } catch (error) {
    dispatch({
      type: REGISTER_FAILURE,
      payload: error
    });
    return { success: false, error };
  }
};





// import { 
//   verificationCallWithValid, 
//   registerUser, 
//   serviceNumberLogin,
//   getUserDetailsByServiceNo,
//   getServiceNumberByPhone,
//   uploadProfileImage,
//   getUserImageUrl
// } from "../service/authService";

// export const AUTH_START = "AUTH_START";
// export const AUTH_SUCCESS = "AUTH_SUCCESS";
// export const AUTH_FAILURE = "AUTH_FAILURE";
// export const RESTORE_SESSION = "RESTORE_SESSION"; 
// export const REGISTER_START = "REGISTER_START";
// export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
// export const REGISTER_FAILURE = "REGISTER_FAILURE";
// export const SERVICE_LOGIN_SUCCESS = "SERVICE_LOGIN_SUCCESS";
// export const SET_USER_DETAILS = "SET_USER_DETAILS";
// export const LOGOUT = "LOGOUT";
// export const SET_SERVICE_NUMBER = "SET_SERVICE_NUMBER";
// export const SET_USER_IMAGE = "SET_USER_IMAGE";
// export const UPLOAD_IMAGE_START = "UPLOAD_IMAGE_START";
// export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
// export const UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE";

// export const setServiceNumber = (serviceNo) => ({
//   type: SET_SERVICE_NUMBER,
//   payload: serviceNo
// });

// export const setUserImage = (imageUrl) => ({
//   type: SET_USER_IMAGE,
//   payload: imageUrl
// });

// export const uploadImageStart = () => ({
//   type: UPLOAD_IMAGE_START
// });

// export const uploadImageSuccess = (imageUrl) => ({
//   type: UPLOAD_IMAGE_SUCCESS,
//   payload: imageUrl
// });

// export const uploadImageFailure = (error) => ({
//   type: UPLOAD_IMAGE_FAILURE,
//   payload: error
// });

// export const restoreSession = () => (dispatch) => {
//   const phoneNumber = localStorage.getItem("phoneNumber");
//   const userData = localStorage.getItem("userData");
//   const sentOtp = localStorage.getItem("sentOtp");
//   const authKey = localStorage.getItem("authKey");
//   const serviceNo = localStorage.getItem("serviceNo");
//   const employeeName = localStorage.getItem("employeeName");
//   const department = localStorage.getItem("department");
//   const role = localStorage.getItem("role");
  
//   // Check for service number login session
//   if (serviceNo && authKey) {
//     let parsedUserData = null;
    
//     if (userData && userData !== "undefined" && userData !== "null") {
//       try {
//         parsedUserData = JSON.parse(userData);
//       } catch (error) {
//         console.warn("Failed to parse userData from localStorage:", error);
//         localStorage.removeItem("userData");
//       }
//     }
    
//     // Set service number in Redux
//     dispatch(setServiceNumber(serviceNo));
    
//     // Set user image URL
//     const imageUrl = getUserImageUrl(serviceNo);
//     dispatch(setUserImage(imageUrl));
    
//     dispatch({
//       type: RESTORE_SESSION,
//       payload: {
//         serviceNo,
//         authKey,
//         userData: parsedUserData || { 
//           Name: employeeName, 
//           Department: department, 
//           Designation: role 
//         },
//         loginMethod: 'service'
//       }
//     });
//     return true;
//   }
  
//   // Check for phone number login session
//   if (phoneNumber) {
//     let parsedUserData = null;
    
//     if (userData && userData !== "undefined" && userData !== "null") {
//       try {
//         parsedUserData = JSON.parse(userData);
//       } catch (error) {
//         console.warn("Failed to parse userData from localStorage:", error);
//         localStorage.removeItem("userData");
//       }
//     }
    
//     // Set service number in Redux if available
//     if (serviceNo) {
//       dispatch(setServiceNumber(serviceNo));
      
//       // Set user image URL
//       const imageUrl = getUserImageUrl(serviceNo);
//       dispatch(setUserImage(imageUrl));
//     }
    
//     dispatch({
//       type: RESTORE_SESSION,
//       payload: {
//         phoneNumber,
//         userData: parsedUserData || { 
//           Name: employeeName, 
//           Department: department, 
//           Designation: role 
//         },
//         serviceNo: serviceNo,
//         sentOtp: sentOtp || null,
//         loginMethod: 'phone'
//       }
//     });
    
//     // If we have service number but no details, fetch them
//     if (serviceNo && (!employeeName || !department || !role)) {
//       dispatch(fetchUserDetails(serviceNo));
//     }
    
//     return true;
//   }
//   return false;
// };

// export const startAuthentication = () => ({
//   type: AUTH_START,
// });

// export const authenticationSuccess = (data) => ({
//   type: AUTH_SUCCESS,
//   payload: data,
// });

// export const authenticationFailure = (error) => ({
//   type: AUTH_FAILURE,
//   payload: error,
// });

// export const setUserData = (userData) => {
//   return {
//     type: "SET_USER_DATA",
//     payload: userData,
//   };
// };

// export const setUserDetails = (userDetails) => {
//   return {
//     type: SET_USER_DETAILS,
//     payload: userDetails,
//   };
// };

// export const logout = () => (dispatch) => {
//   localStorage.removeItem("phoneNumber");
//   localStorage.removeItem("userData");
//   localStorage.removeItem("sentOtp");
//   localStorage.removeItem("authKey");
//   localStorage.removeItem("serviceNo");
//   localStorage.removeItem("employeeId");
//   localStorage.removeItem("employeeName");
//   localStorage.removeItem("department");
//   localStorage.removeItem("role");
  
//   dispatch({
//     type: LOGOUT
//   });
// };

// // Phone number authentication
// export const authenticate = (phoneNo) => async (dispatch) => {
//   dispatch(startAuthentication());
//   try {
//     const response = await verificationCallWithValid(phoneNo);
    
//     if (response.success) {
//       let serviceNo = response.serviceNo;
      
//       // If serviceNo is not in OTP response, try to get it by phone
//       if (!serviceNo) {
//         try {
//           const serviceResponse = await getServiceNumberByPhone(phoneNo);
//           if (serviceResponse.success) {
//             serviceNo = serviceResponse.serviceNo;
//           }
//         } catch (serviceError) {
//           console.warn("Could not fetch service number by phone:", serviceError);
//         }
//       }
      
//       // Store basic info in localStorage
//       localStorage.setItem("phoneNumber", phoneNo);
//       localStorage.setItem("sentOtp", response.otp);
      
//       if (serviceNo) {
//         localStorage.setItem("serviceNo", serviceNo);
//         localStorage.setItem("employeeId", serviceNo);
        
//         // Set service number in Redux
//         dispatch(setServiceNumber(serviceNo));
        
//         // Set user image URL
//         const imageUrl = getUserImageUrl(serviceNo);
//         dispatch(setUserImage(imageUrl));
        
//         // Fetch and store user details
//         try {
//           const userDetailsResponse = await getUserDetailsByServiceNo(serviceNo);
//           if (userDetailsResponse.success && userDetailsResponse.userData) {
//             const userData = userDetailsResponse.userData;
//             localStorage.setItem("employeeName", userData.Name || "");
//             localStorage.setItem("department", userData.Department || "");
//             localStorage.setItem("role", userData.Designation || "");
            
//             dispatch(setUserDetails(userData));
//           }
//         } catch (userError) {
//           console.warn("Could not fetch user details:", userError);
//         }
//       }
      
//       dispatch(authenticationSuccess({ 
//         phoneNumber: phoneNo, 
//         otp: response.otp,
//         serviceNo: serviceNo
//       }));
      
//       return { 
//         success: true, 
//         data: response.otp, 
//         serviceNo: serviceNo 
//       };
//     } else {
//       throw { message: "Invalid phone number or verification failed." };
//     }
//   } catch (error) {
//     dispatch(authenticationFailure(error));
//     return { success: false, error };
//   }
// };

// // Service number authentication
// export const authenticateWithServiceNumber = (serviceNo, password) => async (dispatch) => {
//   dispatch(startAuthentication());
//   try {
//     const response = await serviceNumberLogin(serviceNo, password);
    
//     if (response.success) {
//       // Store auth key and service number in localStorage
//       localStorage.setItem("authKey", response.authKey);
//       localStorage.setItem("serviceNo", serviceNo);
//       localStorage.setItem("employeeId", serviceNo);
//       localStorage.setItem("userData", JSON.stringify(response.userData));
      
//       // Set service number in Redux
//       dispatch(setServiceNumber(serviceNo));
      
//       // Set user image URL
//       const imageUrl = getUserImageUrl(serviceNo);
//       dispatch(setUserImage(imageUrl));
      
//       // Fetch and store user details
//       try {
//         const userDetailsResponse = await getUserDetailsByServiceNo(serviceNo);
//         if (userDetailsResponse.success && userDetailsResponse.userData) {
//           const userData = userDetailsResponse.userData;
//           localStorage.setItem("employeeName", userData.Name || "");
//           localStorage.setItem("department", userData.Department || "");
//           localStorage.setItem("role", userData.Designation || "");
          
//           // Update response with user details
//           response.userData = { ...response.userData, ...userData };
//           localStorage.setItem("userData", JSON.stringify(response.userData));
          
//           dispatch(setUserDetails(userData));
//         }
//       } catch (userError) {
//         console.warn("Could not fetch user details:", userError);
//       }
      
//       dispatch({
//         type: SERVICE_LOGIN_SUCCESS,
//         payload: {
//           serviceNo,
//           authKey: response.authKey,
//           userData: response.userData
//         }
//       });
      
//       return { success: true, data: response };
//     } else {
//       throw { message: "Invalid credentials" };
//     }
//   } catch (error) {
//     dispatch(authenticationFailure(error));
//     return { success: false, error };
//   }
// };

// // Fetch user details by service number
// export const fetchUserDetails = (serviceNo) => async (dispatch) => {
//   try {
//     const response = await getUserDetailsByServiceNo(serviceNo);
    
//     if (response.success && response.userData) {
//       const userData = response.userData;
      
//       // Store in localStorage
//       localStorage.setItem("employeeName", userData.Name || "");
//       localStorage.setItem("department", userData.Department || "");
//       localStorage.setItem("role", userData.Designation || "");
      
//       dispatch(setUserDetails(userData));
//       return { success: true, data: userData };
//     } else {
//       return { success: false, message: response.message };
//     }
//   } catch (error) {
//     console.error("Error fetching user details:", error);
//     return { success: false, error };
//   }
// };

// // Upload profile image action
// export const uploadProfileImageAction = (serviceNo, imageFile) => async (dispatch) => {
//   dispatch(uploadImageStart());
  
//   try {
//     // Validate file
//     const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
//     if (!validTypes.includes(imageFile.type)) {
//       throw new Error("Please select a valid image file (JPEG, PNG, GIF, or WebP)");
//     }
    
//     if (imageFile.size > 5 * 1024 * 1024) {
//       throw new Error("Image size should not exceed 5MB");
//     }
    
//     // Upload image
//     const response = await uploadProfileImage(serviceNo, imageFile);
    
//     if (response.success) {
//       // Update image URL with timestamp to bypass cache
//       const newImageUrl = getUserImageUrl(serviceNo);
//       dispatch(uploadImageSuccess(newImageUrl));
      
//       return { 
//         success: true, 
//         imageUrl: newImageUrl,
//         data: response.data 
//       };
//     } else {
//       throw new Error("Upload failed");
//     }
//   } catch (error) {
//     console.error("Image upload error:", error);
//     dispatch(uploadImageFailure(error.message));
//     return { success: false, error: error.message };
//   }
// };

// // Resend OTP
// export const resendOtp = (phoneNumber) => async (dispatch) => {
//   try {
//     const response = await verificationCallWithValid(phoneNumber);
    
//     if (response.success) {
//       // Update service number if available
//       if (response.serviceNo) {
//         localStorage.setItem("serviceNo", response.serviceNo);
//         localStorage.setItem("employeeId", response.serviceNo);
        
//         // Update Redux state
//         dispatch(setServiceNumber(response.serviceNo));
        
//         // Set user image URL
//         const imageUrl = getUserImageUrl(response.serviceNo);
//         dispatch(setUserImage(imageUrl));
//       }
      
//       return { success: true, data: response.otp, serviceNo: response.serviceNo };
//     } else {
//       throw { message: "Failed to resend OTP." };
//     }
//   } catch (error) {
//     console.error("Error resending OTP:", error);
//     return { success: false, error };
//   }
// };

// // Registration action
// export const register = (userData) => async (dispatch) => {
//   dispatch({ type: REGISTER_START });
  
//   try {
//     const response = await registerUser(userData);
//     dispatch({
//       type: REGISTER_SUCCESS,
//       payload: response
//     });
//     return { success: true, data: response };
//   } catch (error) {
//     dispatch({
//       type: REGISTER_FAILURE,
//       payload: error
//     });
//     return { success: false, error };
//   }
// };











// import { 
//   verificationCallWithValid, 
//   fetchUserData, 
//   registerUser, 
//   serviceNumberLogin,
//   getUserDetailsByServiceNo,
//   getServiceNumberByPhone 
// } from "../service/authService";

// export const AUTH_START = "AUTH_START";
// export const AUTH_SUCCESS = "AUTH_SUCCESS";
// export const AUTH_FAILURE = "AUTH_FAILURE";
// export const RESTORE_SESSION = "RESTORE_SESSION"; 
// export const LOAD_USER_DATA_SUCCESS = "LOAD_USER_DATA_SUCCESS";
// export const LOAD_USER_DATA_FAILURE = "LOAD_USER_DATA_FAILURE";
// export const REGISTER_START = "REGISTER_START";
// export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
// export const REGISTER_FAILURE = "REGISTER_FAILURE";
// export const SERVICE_LOGIN_SUCCESS = "SERVICE_LOGIN_SUCCESS";
// export const SET_USER_DETAILS = "SET_USER_DETAILS";
// export const LOGOUT = "LOGOUT";

// export const restoreSession = () => (dispatch) => {
//   const phoneNumber = localStorage.getItem("phoneNumber");
//   const userData = localStorage.getItem("userData");
//   const sentOtp = localStorage.getItem("sentOtp");
//   const authKey = localStorage.getItem("authKey");
//   const serviceNo = localStorage.getItem("serviceNo");
//   const employeeName = localStorage.getItem("employeeName");
//   const department = localStorage.getItem("department");
//   const role = localStorage.getItem("role");
  
//   // Check for service number login session
//   if (serviceNo && authKey) {
//     let parsedUserData = null;
    
//     if (userData && userData !== "undefined" && userData !== "null") {
//       try {
//         parsedUserData = JSON.parse(userData);
//       } catch (error) {
//         console.warn("Failed to parse userData from localStorage:", error);
//         localStorage.removeItem("userData");
//       }
//     }
    
//     dispatch({
//       type: RESTORE_SESSION,
//       payload: {
//         serviceNo,
//         authKey,
//         userData: parsedUserData || { 
//           Name: employeeName, 
//           Department: department, 
//           Designation: role 
//         },
//         loginMethod: 'service'
//       }
//     });
//     return true;
//   }
  
//   // Check for phone number login session
//   if (phoneNumber) {
//     let parsedUserData = null;
    
//     if (userData && userData !== "undefined" && userData !== "null") {
//       try {
//         parsedUserData = JSON.parse(userData);
//       } catch (error) {
//         console.warn("Failed to parse userData from localStorage:", error);
//         localStorage.removeItem("userData");
//       }
//     }
    
//     dispatch({
//       type: RESTORE_SESSION,
//       payload: {
//         phoneNumber,
//         userData: parsedUserData || { 
//           Name: employeeName, 
//           Department: department, 
//           Designation: role 
//         },
//         serviceNo: serviceNo,
//         sentOtp: sentOtp || null,
//         loginMethod: 'phone'
//       }
//     });
    
//     // If we have service number but no details, fetch them
//     if (serviceNo && (!employeeName || !department || !role)) {
//       dispatch(fetchUserDetails(serviceNo));
//     }
    
//     return true;
//   }
//   return false;
// };

// export const loadUserData = (phoneNumber) => async (dispatch) => {
//   try {
//     const response = await fetchUserData(phoneNumber);
    
//     dispatch({
//       type: LOAD_USER_DATA_SUCCESS,
//       payload: {
//         ...response,
//         correctPhoneFormat: response.correctPhoneFormat,
//       },
//     });
//   } catch (error) {
//     console.error("Error loading user data:", error);
//     dispatch({
//       type: LOAD_USER_DATA_FAILURE,
//       payload: error,
//     });
//   }
// };

// export const startAuthentication = () => ({
//   type: AUTH_START,
// });

// export const authenticationSuccess = (data) => ({
//   type: AUTH_SUCCESS,
//   payload: data,
// });

// export const authenticationFailure = (error) => ({
//   type: AUTH_FAILURE,
//   payload: error,
// });

// export const setUserData = (userData) => {
//   return {
//     type: "SET_USER_DATA",
//     payload: userData,
//   };
// };

// export const setUserDetails = (userDetails) => {
//   return {
//     type: SET_USER_DETAILS,
//     payload: userDetails,
//   };
// };

// export const logout = () => (dispatch) => {
//   localStorage.removeItem("phoneNumber");
//   localStorage.removeItem("userData");
//   localStorage.removeItem("sentOtp");
//   localStorage.removeItem("authKey");
//   localStorage.removeItem("serviceNo");
//   localStorage.removeItem("employeeId");
//   localStorage.removeItem("employeeName");
//   localStorage.removeItem("department");
//   localStorage.removeItem("role");
  
//   dispatch({
//     type: LOGOUT
//   });
// };

// // Phone number authentication (Updated to fetch service number and user details)
// export const authenticate = (phoneNo) => async (dispatch) => {
//   dispatch(startAuthentication());
//   try {
//     const response = await verificationCallWithValid(phoneNo);
    
//     if (response.success) {
//       let serviceNo = response.serviceNo;
      
//       // If serviceNo is not in OTP response, try to get it by phone
//       if (!serviceNo) {
//         try {
//           const serviceResponse = await getServiceNumberByPhone(phoneNo);
//           if (serviceResponse.success) {
//             serviceNo = serviceResponse.serviceNo;
//           }
//         } catch (serviceError) {
//           console.warn("Could not fetch service number by phone:", serviceError);
//         }
//       }
      
//       // Store basic info in localStorage
//       localStorage.setItem("phoneNumber", phoneNo);
//       localStorage.setItem("sentOtp", response.otp);
      
//       if (serviceNo) {
//         localStorage.setItem("serviceNo", serviceNo);
//         localStorage.setItem("employeeId", serviceNo);
        
//         // Fetch and store user details
//         try {
//           const userDetailsResponse = await getUserDetailsByServiceNo(serviceNo);
//           if (userDetailsResponse.success && userDetailsResponse.userData) {
//             const userData = userDetailsResponse.userData;
//             localStorage.setItem("employeeName", userData.Name || "");
//             localStorage.setItem("department", userData.Department || "");
//             localStorage.setItem("role", userData.Designation || "");
            
//             dispatch(setUserDetails(userData));
//           }
//         } catch (userError) {
//           console.warn("Could not fetch user details:", userError);
//         }
//       }
      
//       dispatch(authenticationSuccess({ 
//         phoneNumber: phoneNo, 
//         otp: response.otp,
//         serviceNo: serviceNo
//       }));
      
//       return { 
//         success: true, 
//         data: response.otp, 
//         serviceNo: serviceNo 
//       };
//     } else {
//       throw { message: "Invalid phone number or verification failed." };
//     }
//   } catch (error) {
//     dispatch(authenticationFailure(error));
//     return { success: false, error };
//   }
// };

// // NEW: Service number authentication
// export const authenticateWithServiceNumber = (serviceNo, password) => async (dispatch) => {
//   dispatch(startAuthentication());
//   try {
//     const response = await serviceNumberLogin(serviceNo, password);
    
//     if (response.success) {
//       // Store auth key and service number in localStorage
//       localStorage.setItem("authKey", response.authKey);
//       localStorage.setItem("serviceNo", serviceNo);
//       localStorage.setItem("employeeId", serviceNo);
//       localStorage.setItem("userData", JSON.stringify(response.userData));
      
//       // Fetch and store user details
//       try {
//         const userDetailsResponse = await getUserDetailsByServiceNo(serviceNo);
//         if (userDetailsResponse.success && userDetailsResponse.userData) {
//           const userData = userDetailsResponse.userData;
//           localStorage.setItem("employeeName", userData.Name || "");
//           localStorage.setItem("department", userData.Department || "");
//           localStorage.setItem("role", userData.Designation || "");
          
//           // Update response with user details
//           response.userData = { ...response.userData, ...userData };
//           localStorage.setItem("userData", JSON.stringify(response.userData));
          
//           dispatch(setUserDetails(userData));
//         }
//       } catch (userError) {
//         console.warn("Could not fetch user details:", userError);
//       }
      
//       dispatch({
//         type: SERVICE_LOGIN_SUCCESS,
//         payload: {
//           serviceNo,
//           authKey: response.authKey,
//           userData: response.userData
//         }
//       });
      
//       return { success: true, data: response };
//     } else {
//       throw { message: "Invalid credentials" };
//     }
//   } catch (error) {
//     dispatch(authenticationFailure(error));
//     return { success: false, error };
//   }
// };

// // Fetch user details by service number
// export const fetchUserDetails = (serviceNo) => async (dispatch) => {
//   try {
//     const response = await getUserDetailsByServiceNo(serviceNo);
    
//     if (response.success && response.userData) {
//       const userData = response.userData;
      
//       // Store in localStorage
//       localStorage.setItem("employeeName", userData.Name || "");
//       localStorage.setItem("department", userData.Department || "");
//       localStorage.setItem("role", userData.Designation || "");
      
//       dispatch(setUserDetails(userData));
//       return { success: true, data: userData };
//     } else {
//       return { success: false, message: response.message };
//     }
//   } catch (error) {
//     console.error("Error fetching user details:", error);
//     return { success: false, error };
//   }
// };

// // Resend OTP
// export const resendOtp = (phoneNumber) => async (dispatch) => {
//   try {
//     const response = await verificationCallWithValid(phoneNumber);
    
//     if (response.success) {
//       // Update service number if available
//       if (response.serviceNo) {
//         localStorage.setItem("serviceNo", response.serviceNo);
//         localStorage.setItem("employeeId", response.serviceNo);
//       }
      
//       return { success: true, data: response.otp, serviceNo: response.serviceNo };
//     } else {
//       throw { message: "Failed to resend OTP." };
//     }
//   } catch (error) {
//     console.error("Error resending OTP:", error);
//     return { success: false, error };
//   }
// };

// // Registration action
// export const register = (userData) => async (dispatch) => {
//   dispatch({ type: REGISTER_START });
  
//   try {
//     const response = await registerUser(userData);
//     dispatch({
//       type: REGISTER_SUCCESS,
//       payload: response
//     });
//     return { success: true, data: response };
//   } catch (error) {
//     dispatch({
//       type: REGISTER_FAILURE,
//       payload: error
//     });
//     return { success: false, error };
//   }
// };